import {
  createCustomToolbarExtension,
  createToolbarMoreMenuConfig,
} from '@affine/core/blocksuite/view-extensions/editor-config/toolbar';
import { WorkspaceServerService } from '@affine/core/modules/cloud';
import { WorkspaceDialogService } from '@affine/core/modules/dialogs';
import { EditorSettingService } from '@affine/core/modules/editor-setting';
import { JournalService } from '@affine/core/modules/journal';
import { ToolbarMoreMenuConfigExtension } from '@blocksuite/affine/components/toolbar';
import {
  EditorSettingExtension,
  JournalExtension,
} from '@blocksuite/affine/shared/services';
import type { ExtensionType } from '@blocksuite/store';
import type { FrameworkProvider } from '@toeverything/infra';

export function getEditorSettingExtension(
  framework: FrameworkProvider
): ExtensionType {
  const { editorSetting } = framework.get(EditorSettingService);
  return EditorSettingExtension({
    setting$: editorSetting.settingSignal,
    set: (key, value) => editorSetting.set(key, value),
  });
}

export function getEditorConfigExtension(
  framework: FrameworkProvider
): ExtensionType[] {
  const editorSettingService = framework.get(EditorSettingService);
  const journalService = framework.get(JournalService);
  const workspaceDialogService = framework.get(WorkspaceDialogService);
  const workspaceServerService = framework.get(WorkspaceServerService);
  const baseUrl = workspaceServerService.server?.baseUrl ?? location.origin;

  return [
    getEditorSettingExtension(framework),
    ToolbarMoreMenuConfigExtension(createToolbarMoreMenuConfig(framework)),
    JournalExtension({
      ensureJournalDoc: date => journalService.ensureJournalByDate(date).id,
      selectDate: position =>
        new Promise(resolve => {
          let resolved = false;
          const resolveOnce = (date?: string) => {
            if (resolved) return;
            resolved = true;
            resolve(date);
          };
          const id = workspaceDialogService.open(
            'date-selector',
            {
              position,
              onSelect: date => {
                resolveOnce(date);
                workspaceDialogService.close(id, date);
              },
            },
            date => {
              resolveOnce(date);
            }
          );
        }),
    }),

    createCustomToolbarExtension(editorSettingService.editorSetting, baseUrl),
  ].flat();
}
